import { useState } from "react";
import { motion } from "framer-motion";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { Logo } from "../Logo";

export function AdminLogin({ onLoggedIn }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError("");
    try {
      await api.post("/admin/login", { password });
      onLoggedIn();
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050A15] flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm kb-glass rounded-2xl p-8"
      >
        <div className="flex justify-center mb-6">
          <Logo size={56} />
        </div>
        <div className="kb-label mb-2 text-center">Admin</div>
        <h1 className="font-display text-2xl font-bold text-white text-center leading-snug">Sign in to the dashboard</h1>

        <form onSubmit={onSubmit} className="mt-8 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-white/60 mb-2">Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoFocus
                data-testid="admin-password-input"
                className="w-full bg-[#0a1f4d]/60 border border-[#d4a840]/20 rounded-xl pl-11 pr-4 py-3 text-white placeholder-white/30 focus:border-[#d4a840] focus:outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>
          </div>

          {error ? <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p> : null}

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="kb-btn-primary w-full justify-center disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {submitting ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : <>Sign in <ArrowRight size={16} /></>}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
